export default __webpack_public_path__ + "static/media/osama.a6508c00.png";